import { useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function LaporanLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch(API_URL + "/api/admin/laporan-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.detail || "Username atau password salah");
      } else {
        localStorage.setItem("laporan_token", data.token);
        onLogin(true);
      }
    } catch (err) {
      setError("Gagal terhubung ke server. Coba lagi.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">📊</span>
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Laporan Bulanan</h1>
          <p className="text-slate-500 text-sm mt-1">Wonderful Images Kemenpar</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition"
              placeholder="admin@laporan.com"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition"
              placeholder="••••••"
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white py-3 rounded-xl font-semibold transition disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                Memverifikasi...
              </>
            ) : (
              "Masuk"
            )}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-sm text-slate-500 hover:text-amber-600 transition">
            ← Kembali ke Website
          </a>
        </div>
      </div>
    </div>
  );
}

function LaporanDashboard({ onLogout }) {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [downloading, setDownloading] = useState(false);

  const months = [
    { value: 1, label: "Januari" },
    { value: 2, label: "Februari" },
    { value: 3, label: "Maret" },
    { value: 4, label: "April" },
    { value: 5, label: "Mei" },
    { value: 6, label: "Juni" },
    { value: 7, label: "Juli" },
    { value: 8, label: "Agustus" },
    { value: 9, label: "September" },
    { value: 10, label: "Oktober" },
    { value: 11, label: "November" },
    { value: 12, label: "Desember" },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const handleDownloadReport = async () => {
    setDownloading(true);
    try {
      const monthName = months.find(m => m.value === selectedMonth).label;

      const token = localStorage.getItem("laporan_token");
      if (!token) throw new Error("Sesi berakhir, silakan login ulang");

      // Download report — pakai token dari login /laporan sendiri (bukan admin utama)
      const response = await fetch(
        API_URL + `/api/admin/reports/monthly?token=${token}&year=${selectedYear}&month=${selectedMonth}`
      );

      if (response.status === 401) {
        localStorage.removeItem("laporan_token");
        throw new Error("Sesi berakhir, silakan login ulang");
      }
      if (!response.ok) throw new Error("Gagal generate laporan");
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Laporan_WonderfulImages_${monthName}_${selectedYear}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      alert("Gagal generate laporan: " + err.message);
    } finally {
      setDownloading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("laporan_token");
    onLogout();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center">
              <span className="text-xl">📊</span>
            </div>
            <div>
              <h1 className="font-bold text-slate-800">Laporan Bulanan</h1>
              <p className="text-xs text-slate-500">Wonderful Images Kemenpar</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="text-sm text-slate-500 hover:text-red-600 transition flex items-center gap-1"
          >
            <span>Logout</span>
            <span>→</span>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-10">
        {/* Download Card */}
        <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 mb-8">
          <h2 className="text-xl font-bold text-slate-800 mb-2">Generate Laporan PDF</h2>
          <p className="text-slate-600 mb-8">
            Download laporan bulanan dalam format PDF profesional dengan charts, statistik, dan analisis AI.
          </p>

          <div className="flex flex-wrap items-end gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Bulan</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                className="px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-white min-w-[150px]"
              >
                {months.map((m) => (
                  <option key={m.value} value={m.value}>{m.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Tahun</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                className="px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-white min-w-[120px]"
              >
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>

            <button
              onClick={handleDownloadReport}
              disabled={downloading}
              className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition disabled:opacity-50 flex items-center gap-2"
            >
              {downloading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                  Generating...
                </>
              ) : (
                <>
                  <span>📥</span>
                  Download Laporan
                </>
              )}
            </button>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 border border-blue-200">
            <h3 className="font-semibold text-blue-900 mb-3 flex items-center gap-2">
              <span>📄</span> Isi Laporan
            </h3>
            <ul className="text-sm text-blue-800 space-y-2">
              <li>✅ Cover page profesional dengan logo Kemenpar</li>
              <li>✅ Daftar Isi (Table of Contents)</li>
              <li>✅ Ringkasan Eksekutif (AI-generated)</li>
              <li>✅ Statistik utama dengan perbandingan</li>
              <li>✅ Top 10 artikel terpopuler</li>
              <li>✅ List artikel baru bulan ini</li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6 border border-purple-200">
            <h3 className="font-semibold text-purple-900 mb-3 flex items-center gap-2">
              <span>📈</span> Visualisasi & Charts
            </h3>
            <ul className="text-sm text-purple-800 space-y-2">
              <li>📉 Line Chart - Trend artikel 6 bulan terakhir</li>
              <li>🥧 Pie Chart - Distribusi per kategori</li>
              <li>📊 Bar Chart - Top provinsi by views</li>
              <li>📋 Tabel breakdown provinsi & kategori</li>
            </ul>
          </div>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-2xl p-6 border border-green-200 mb-8">
          <h3 className="font-semibold text-green-900 mb-3 flex items-center gap-2">
            <span>🤖</span> AI-Powered Insights
          </h3>
          <div className="grid md:grid-cols-3 gap-4 text-sm">
            <div className="bg-white/60 rounded-xl p-4">
              <p className="font-medium text-green-800 mb-1">Ringkasan Eksekutif</p>
              <p className="text-green-700 text-xs">Analisis otomatis performa bulan ini</p>
            </div>
            <div className="bg-white/60 rounded-xl p-4">
              <p className="font-medium text-green-800 mb-1">Analisis Data</p>
              <p className="text-green-700 text-xs">Insight distribusi konten & trend</p>
            </div>
            <div className="bg-white/60 rounded-xl p-4">
              <p className="font-medium text-green-800 mb-1">Rekomendasi Strategis</p>
              <p className="text-green-700 text-xs">Saran pengembangan konten</p>
            </div>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
          <h3 className="font-semibold text-amber-900 mb-2 flex items-center gap-2">
            <span>💡</span> Info Penting
          </h3>
          <p className="text-sm text-amber-800">
            Laporan menggunakan <strong>OpenAI GPT-4o-mini</strong> untuk generate narasi analisis dan rekomendasi.
            PDF berisi <strong>9 halaman</strong> dengan watermark logo Kemenpar.
            Proses generate memerlukan waktu <strong>10-20 detik</strong>.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white mt-10">
        <div className="max-w-4xl mx-auto px-6 py-6 text-center text-sm text-slate-500">
          © 2026 Wonderful Images — Kementerian Pariwisata dan Ekonomi Kreatif RI
        </div>
      </footer>
    </div>
  );
}

export default function LaporanPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!localStorage.getItem("laporan_token");
  });

  if (!isLoggedIn) {
    return <LaporanLogin onLogin={setIsLoggedIn} />;
  }

  return <LaporanDashboard onLogout={() => setIsLoggedIn(false)} />;
}
